import { useEffect, useState } from 'react';
import { Box, CardActions, styled, TableContainer } from '@mui/material';
import { QCard, QCardHeader, QCardContent, QTypography, QTable, QTableBody, QTableCell, QTableRow, QTableHead } from '@kw/quokka-ui';
import { PageLoader } from '../../PageLoader';
import { DateRangeSelect } from './DateRangeSelect';

export function DashboardExpandableDataCard({
  initialDateRange = 7,
  title = '',
  data = [],
  minRowShow = 4,
  maxRowShow = 10,
  columns = [],
  functionToFetch,
  isLoading = false,
  rowIdField,
}: {
  initialDateRange: number;
  title: string;
  data: any[];
  minRowShow: number;
  maxRowShow: number;
  columns: any[];
  functionToFetch: ({ range }: { range: number }) => void;
  isLoading?: boolean;
  rowIdField: string;
}) {
  const [seeAll, setSeeAll] = useState(false);
  const [selectedDateRange, setSelectedDateRange] = useState(initialDateRange);

  useEffect(() => {
    setSelectedDateRange(initialDateRange);
    functionToFetch({ range: initialDateRange });
  }, [initialDateRange]);

  const shownData = seeAll ? data.slice(0, maxRowShow) : data.slice(0, minRowShow);

  const handleDateRangeChange = event => {
    setSelectedDateRange(event.target.value);
    functionToFetch({ range: Number(event.target.value) });
  };

  return (
    <QCard>
      <QCardHeader
        title={
          <Box display="flex" justifyContent="space-between">
            <QTypography variant="h4Medium">{title}</QTypography>
            <DateRangeSelect selectedDateRange={selectedDateRange} handleDateRangeChange={handleDateRangeChange} />
          </Box>
        }
      />
      <QCardContent>
        {isLoading && <PageLoader />}
        <TableContainer>
          <QTable aria-label="customized table">
            <QTableHead>
              <QTableRow>
                {columns.map(column => (
                  <QTableCell key={column.label} align={column.align}>
                    {column.label}
                  </QTableCell>
                ))}
              </QTableRow>
            </QTableHead>
            <QTableBody>
              {shownData.map(row => (
                <QTableRow key={row[rowIdField]}>
                  {columns.map(column => (
                    <QTableCell key={`${column.label}`} align={column.align}>
                      {column.component ? column.component({ row, value: row[column.keyName] }) : row[column.keyName]}
                    </QTableCell>
                  ))}
                </QTableRow>
              ))}
            </QTableBody>
          </QTable>
        </TableContainer>
      </QCardContent>
      <StyledCardActions>
        <StyledClickableText onClick={() => setSeeAll(!seeAll)}>{seeAll ? 'See less' : 'See all'}</StyledClickableText>
      </StyledCardActions>
    </QCard>
  );
}

const StyledCardActions = styled(CardActions)({
  justifyContent: 'center',
});

const StyledClickableText = styled(QTypography)({
  cursor: 'pointer',
});
